
import axios from "axios";
import { store } from "store";
import { OutputBaseProps } from "utils/types/API";
import { MessageItemProps } from ".";
import { loading, create } from "store/message";
import { AppMessage } from "components";

interface ApiMessageCreateInputProps extends Omit<MessageItemProps, "id"> {
}

type ApiMessageCreateOutputProps = OutputBaseProps<{ item: MessageItemProps; }, ApiMessageCreateInputProps>;

export const apiMessageCreate = async (data: ApiMessageCreateInputProps) => {
    store.dispatch(loading());
    const res = (await axios.post<ApiMessageCreateOutputProps>("/api/message/create", data))
        .data;
    if (res.code === 0 && res.data) {
        store.dispatch(create({ data: res.data.item }));
        AppMessage.success({
            title: "Thông báo",
            message: res.message
        })
    }
    return res;
};

export const apiMessageSend = async (data: ApiMessageCreateInputProps) => {
    store.dispatch(loading());
    const res = (await axios.post<ApiMessageCreateOutputProps>("/api/message/send", data))
        .data;
    if (res.code === 0 && res.data) {
        store.dispatch(create({ data: res.data.item }));
        AppMessage.success({
            title: "Gửi tin nhắn thành công!",
            message: "Cảm ơn bạn đã liên hệ với chúng tôi."
        })
    }
    return res;
};